import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Divider } from 'antd'
import { ObjectiveStatus, EmployeeDisplayFragment, ObjectiveDto } from '../../../types'
import { ObjectiveList, ObjectiveListType } from './lists/ObjectivesList'
import { filterObjectivesByTypeStatusAndRefYear } from './util'
import PerSpacer from '../../../components/custom_components/Spacer'
import PerText from '../../../components/custom_components/Text'
import { ConclusionTargetModal } from '../../../components/custom_components/ObjectiveModal/ConclusionTargetModal'
import { useAuth } from '../../../context/auth-context'
import { PerModal } from '../../../components/custom_components/Modal'
import { OkrModalTitle } from './components/OkrModalTitle'
import useObjectiveWithModalInMeeting from '../../../graphql/objectives/useObjectiveWithModalInMeeting'

interface Props {
  employee: EmployeeDisplayFragment
  meetingId: string
  objectives: ObjectiveDto[]
}

const ConclusionDismissedObjectives: FC<Props> = ({ employee, meetingId, objectives }) => {
  const [t] = useTranslation()
  const { user } = useAuth()
  const { open, close, objective, handleObjectiveChange } = useObjectiveWithModalInMeeting({ meetingId })

  const dismissedMonetaryObjectives = filterObjectivesByTypeStatusAndRefYear(objectives, true, [ObjectiveStatus.DismissedPending])
  const dismissedDevObjectives = filterObjectivesByTypeStatusAndRefYear(objectives, false, [ObjectiveStatus.DismissedPending])

  return (
    <>
      {(!!dismissedMonetaryObjectives.length || !!dismissedDevObjectives.length) && (
        <div data-e2e-new-targets-conclusion>
          {objective && (
            <PerModal
              visible={open}
              onCancel={close}
              size="large"
              title={{ custom: <OkrModalTitle title={objective && objective.title} objective={objective} /> }}
            >
              <ConclusionTargetModal objective={objective} employeeId={employee.id} user={user} />
            </PerModal>
          )}

          <PerText appearance="heading" color="primary" mb="s">
            {t('appraisalMeeting.stepConclusion.dismissedTargets')}
          </PerText>
          {!!dismissedMonetaryObjectives.length && (
            <PerSpacer mb="m">
              <ObjectiveList
                listType={ObjectiveListType.Monetary}
                objectives={dismissedMonetaryObjectives}
                disabled={true}
                handleObjectiveClicked={handleObjectiveChange}
                isManagerPreparation={false}
                showTasks
                hideAction
                showStartDate
              />
            </PerSpacer>
          )}
          {!!dismissedDevObjectives.length && (
            <ObjectiveList
              listType={ObjectiveListType.Development}
              objectives={dismissedDevObjectives}
              disabled={true}
              isManagerPreparation={false}
              handleObjectiveClicked={handleObjectiveChange}
              showTasks
              hideAction
              showStartDate
            />
          )}

          <Divider />
        </div>
      )}
    </>
  )
}
export { ConclusionDismissedObjectives }
